
import React, { createContext, useState, useContext } from "react";

const SadtContext = createContext();

export default function AmbienteProvider({ children }) {
  const [energiaEquipamento_id, setEnergiaEquipamento_id] = useState();

  return (
    <SadtContext.Provider value={{ energiaEquipamento_id, setEnergiaEquipamento_id }} >
      {children}
    </SadtContext.Provider>
  );
}

export function useSadtContext() {
  const context = useContext(SadtContext);
  //if (!context) throw new Error("useCount must be used within a CountProvider");
  const { energiaEquipamento_id, setEnergiaEquipamento_id } = context;
  return { energiaEquipamento_id, setEnergiaEquipamento_id };
}

